// Installs `window.__gm` (IMPLEMENTATION §2.9): active with ?test, ?debug, in DEV and in the test build.
import type { GmHooks } from './gmTypes.ts';

export function installTestHooks(win: Window, hooks: GmHooks): void {
  win.__gm = hooks;
}

export interface Deferred {
  promise: Promise<void>;
  resolve(): void;
  /** Boot failed (unsupported browser, exception): awaiters of `__gm.ready` fail fast with the cause. */
  reject(err: unknown): void;
}

export function deferred(): Deferred {
  let resolve: () => void = () => undefined;
  let reject: (err: unknown) => void = () => undefined;
  const promise = new Promise<void>((res, rej) => {
    resolve = res;
    reject = rej;
  });
  // Nobody may be awaiting __gm.ready (DEV, ?debug): a failed boot must not add an unhandledrejection.
  promise.catch(() => undefined);
  return { promise, resolve, reject };
}
